/**
 * Created on 2025-08-11.
 * Copyright © 2025 Curriculum Ltd. All rights reserved.
 */

import { Component } from '@angular/core';

@Component({
  selector: 'curr-terms-of-use-page',
  templateUrl: './terms-of-use-page.component.html',
  styleUrls: ['./terms-of-use-page.component.scss']
})
export class TermsOfUsePageComponent {}
